module.exports = __webpack_public_path__ + "static/media/SUNSHINE COAST REGIONAL.806149f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/SUNSHINE COAST REGIONAL.svg
// module id = 583
// module chunks = 0